import { Record } from 'immutable';
export const LogEventMessageKeys = {
  FIELD_KEY: 'fieldKey',
  PATH: 'path',
  IS_JSX_MESSAGE: 'isJSXMessage',
  IS_PRIMARY_RISK_MESSAGE: 'isPrimaryRiskMessage',
  IS_SECONDARY_RISK_MESSAGE: 'isSecondaryRiskMessage'
};
const defaultProps = {
  [LogEventMessageKeys.FIELD_KEY]: undefined,
  [LogEventMessageKeys.PATH]: undefined,
  [LogEventMessageKeys.IS_JSX_MESSAGE]: undefined,
  [LogEventMessageKeys.IS_PRIMARY_RISK_MESSAGE]: undefined,
  [LogEventMessageKeys.IS_SECONDARY_RISK_MESSAGE]: undefined
};
export default class LogEventMessage extends Record(defaultProps, 'LogEventMessage') {}